import * as RegionMarketActionType from './constants';
import * as CommonActionType from '../Common/constants';

const defaultParams = {
  searchKey: '',
  skip: 1,
  take: 100,
  sort: { field: 'name', order: 'ascending' },
  totalRecord: 0,
  totalPage: 0
};

const ManageRegionMarket = {
  items: [],
  params: defaultParams
};

const RegionProfile = {
  id: '',
  name: '',
  description: ''
};

const MarketProfile = {
  id: '',
  name: '',
  description: '',
  regionId: ''
};

const RegionMarketState = {
  ManageRegionMarket: ManageRegionMarket,
  RegionProfile: RegionProfile,
  MarketProfile: MarketProfile,
  ErrorMsg: [],
  isOpenFormAddEditRegion: false,
  isOpenFormAddEditMarket: false,
  Title: 'New',
  IsCreate: true,
  dateTime: new Date(),
  SelectListRegions: [],
  SelectListMarkets: [],
  RegionAWSCredential: null,
  RegionPODocuments: []
};

export default function RegionMarketStore(state = RegionMarketState, action) {
  switch (action.type) {
    case RegionMarketActionType.SEARCH_REGION_SUCCESS:
      return processSearchSuccess(state, action);
    case RegionMarketActionType.OPEN_FORM_CREATE_REGION:
      return {
        ...state,
        RegionProfile: RegionProfile,
        Title: 'New',
        ErrorMsg: [],
        IsCreate: true,
        isOpenFormAddEditRegion: true,
        isOpenFormAddEditMarket: false,
        dateTime: new Date()
      };
    case RegionMarketActionType.OPEN_FORM_CREATE_MARKET:
      return {
        ...state,
        MarketProfile: MarketProfile,
        Title: 'New',
        ErrorMsg: [],
        IsCreate: true,
        isOpenFormAddEditRegion: false,
        isOpenFormAddEditMarket: true,
        dateTime: new Date()
      };
    case RegionMarketActionType.GET_REGION_BY_ID_SUCCESS:
      return processGetRegionByIdSuccess(state, action);
    case RegionMarketActionType.GET_MARKET_BY_ID_SUCCESS:
      return processGetMarketByIdSuccess(state, action);
    case CommonActionType.COMMON_SELECT_LIST_REGION_SUCCESS:
      return processSelectListRegion(state, action);
    case RegionMarketActionType.ADD_EDIT_REGION_MARKET_ERROR:
      return processAddEditError(state, action);
    case RegionMarketActionType.RESET_REGION_MARKET:
      return {
        ...state,
        isOpenFormAddEditRegion: false,
        isOpenFormAddEditMarket: false
      };
      //case RegionMarketActionType.RESET_TRADE:
      //    return {
      //        ...state,
      //        ManageTrade: {
      //            ...state.ManageTrade,
      //            params: defaultParams
      //        },
      //    };
    case RegionMarketActionType.GET_LIST_REGION_SUCCESS:
      return {
        ...state,
        SelectListRegions: action.data
      };
    case RegionMarketActionType.GET_LIST_MARKET_SUCCESS:
      return {
        ...state,
        SelectListMarkets: action.data
      };
    case RegionMarketActionType.SETUP_REGION_PO_AWS_SUCCESS:
      return {
        ...state,
        RegionAWSCredential: action.data
      };
    case RegionMarketActionType.UPLOAD_REGION_PO_TO_SERVER_SUCCESS:
      return {
        ...state,
        RegionPODocuments: [...state.RegionPODocuments, ...action.data]
      };
    case RegionMarketActionType.GET_REGION_PO_SUCCESS:
      return {
        ...state,
        RegionPODocuments: action.data
      };
    case RegionMarketActionType.RESET_REGION_PO:
      return {
        ...state,
        RegionPODocuments: []
      };
    default:
      return state;
  }
}

const processSearchSuccess = (state, action) => {
  var result = action.data;
  var manageRegionMarket = {
    items: result.data.items,
    params: {
      totalRecord: result.data.totalRecord,
      totalPage: result.data.totalPage,
      skip: result.params.skip + 1,
      take: result.params.take,
      name: result.params.name,
      sort: { field: result.params.sortField, order: result.params.sortOrder }
    }
  };

  return {
    ...state,
    ManageRegionMarket: manageRegionMarket,
    ErrorMsg: [],
    isOpenFormAddEditRegion: false,
    isOpenFormAddEditMarket: false,
    SelectListRegions: [],
    RegionProfile: RegionProfile,
    MarketProfile: MarketProfile
  };
};

const processGetRegionByIdSuccess = (state, action) => {

  return {
    ...state,
    RegionProfile: action.data,
    Title: 'Edit',
    ErrorMsg: [],
    IsCreate: false,
    isOpenFormAddEditRegion: true,
    isOpenFormAddEditMarket: false
  };
};

const processGetMarketByIdSuccess = (state, action) => {

  return {
    ...state,
    MarketProfile: action.data,
    Title: 'Edit',
    ErrorMsg: [],
    IsCreate: false,
    isOpenFormAddEditRegion: false,
    isOpenFormAddEditMarket: true
  };
};

const processAddEditError = (state, action) => {
  return {
    ...state,
    ErrorMsg: [action.data.error],
    RegionProfile: action.data.params,
    MarketProfile: action.data.params
  };
};

const processSelectListRegion = (state, action) => {

  return {
    ...state,
    SelectListRegions: action.data,
    isOpenFormAddEditMarket: true
  };
};



// WEBPACK FOOTER //
// ./src/Region-Market/reducers.js